import '../assets/styles/Main.scss';

import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

import avatar from '../assets/images/avatar.png';

function Main() {
  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={avatar} alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/dark-dylan-dev" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/dylan-hollemaert/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
          <h1>Dylan Hollemaert</h1>
          <p>Game dev & Graphics Programming student</p>

          <div className="mobile_social_icons">
            <a href="https://github.com/dark-dylan-dev" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/dylan-hollemaert/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;